import { Stack, Tooltip } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { Select } from '@/components/Form/Select';
import { Icon } from '@/components/Icon/Icon';

import { useTranslate } from '@/hooks/useTranslate';

import { Option } from '@/types/components/common';
import { AddressForm } from '@/types/form';

type CountryOfResidenceFieldProps = Readonly<{
  isDisabled?: boolean;
  popularCountryOptions: Option[];
  hideLabel?: boolean;
  helperText?: string;
}>;

export function CountryOfResidenceField({
  isDisabled = false,
  popularCountryOptions,
  hideLabel = false,
  helperText,
}: CountryOfResidenceFieldProps) {
  const { t } = useTranslate();
  const {
    control,
    formState: { errors: visibleErrors },
  } = useFormContext<AddressForm>();

  return (
    <Stack
      mt={hideLabel ? 0.25 : 1}
      direction="row"
      alignItems="center"
      spacing={0.5}
      width="100%"
    >
      <Select
        options={popularCountryOptions}
        control={control}
        name="residenceCountry"
        error={!!visibleErrors.residenceCountry}
        helperText={visibleErrors.residenceCountry?.message || helperText}
        rules={{
          required: t(
            'createNewAccount.addressPage.form.residenceCountry.error.required',
          ),
        }}
        fullWidth
        disabled={isDisabled}
        placeholder={t(
          'createNewAccount.addressPage.form.residenceCountry.placeHolder',
        )}
        label={
          hideLabel
            ? ''
            : t('createNewAccount.addressPage.form.residenceCountry.label')
        }
        aria-label={t(
          'createNewAccount.addressPage.form.residenceCountry.label',
        )}
        useDrawerOnMobile
        withSearchBar
      />

      <Tooltip
        title={t('createNewAccount.addressPage.form.residenceCountry.tooltip')}
        placement="top"
        arrow
        enterTouchDelay={0}
      >
        <span>
          <Icon
            name="info-outline"
            color={theme => theme.palette.neutral[700]}
          />
        </span>
      </Tooltip>
    </Stack>
  );
}
